<template>
  <div>
    <v-btn
      v-if="status != '*'"
      block
      dark
      tile
      depressed
      :color="getColor(status)"
    >
      {{ status }}
    </v-btn>
    <div v-else>*</div>
  </div>
</template>

<script>
export default {
  props: {
    status: String,
  },
  methods: {
    getColor(status) {
      status = status ? status.toLowerCase() : "";
      if (status == "success") return "green";
      if (status == "failed") return "red";
      return "primary";
    },
  },
};
</script>

<style>
</style>